import ApiService from './api.service'
import { TokenService } from './storage.service'

const PubQuoteEditService = {
    saveSalesRepQuote: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteEdit/SaveSalesRepQuote',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    saveQuoteItem: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteEdit/SaveQuoteItem',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    applyPromotionToQuoteItem: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteEdit/ApplyPromotionToQuoteItem',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    populateNewQuote: async () => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteEdit/PopulateNewQuote',
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    populateQuoteEditDataForSalesRep: async (id) => {
        const requestData = {
            method: 'post',
            url: `/api/QuoteEdit/PopulateQuoteEditDataForSalesRep?id=${id}`,
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    populateQuoteEditDataForInternalRep: async (id) => {
        const requestData = {
            method: 'post',
            url: `/api/QuoteEdit/PopulateQuoteEditDataForInternalRep?id=${id}`,
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    populateQuoteEditLookups: async (facilityIdAndTerritoryIdPayload) => {
        const requestData = {
            method: 'post',
            url: `/api/QuoteEdit/PopulateQuoteEditLookups`,
            data: facilityIdAndTerritoryIdPayload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },

    //Quote Item Template Form Related
    getQuoteTemplateForQuote: async (templateSearch) => {
        const requestData = {
            method: 'post',
            url: `/api/QuoteEdit/GetQuoteTemplateForQuote`,
            data: templateSearch,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    saveQuoteTemplateForQuote: async (template) => {
        const requestData = {
            method: 'post',
            url: `/api/QuoteEdit/SaveQuoteTemplateForQuote`,
            data: template,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    //End Quote Item Template Form Related

    //Quote DMS Configurator Related
    getDmsConfiguratorItems: async (quoteId) => {
        const requestData = {
            method: 'post',
            url: `/api/QuoteEdit/GetDmsConfiguratorItems?quoteId=${quoteId}`,
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    saveDmsItemsToQuote: async (dmsItems) => {
        const requestData = {
            method: 'post',
            url: `/api/QuoteEdit/SaveDmsItemsToQuote`,
            data: dmsItems,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    getDmsItemPrice: async (quoteId, itemNumber, catalogNum, quantity) => {
        const requestData = {
            method: 'post',
            url: `/api/QuoteEdit/GetDmsItemPrice?quoteId=${quoteId}&itemNumber=${encodeURIComponent(itemNumber)}&catalogNum=${encodeURIComponent(catalogNum)}&quantity=${quantity}`,
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    //End Quote DMS Configurator Related

    // SoldTo Search
    getSoldToListByFacility: async (facilityId) => {
        const requestData = {
            method: 'post',
            url: '/api/SoldToSearch/GetSoldToListByFacility',
            data: { facilityId: facilityId },
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },

    addQuoteAsOppotunity: async (id) => {
        const requestData = {
            method: 'post',
            url: `/api/QuoteEdit/AddQuoteAsOppotunity?id=${id}`,
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            // console.log(JSON.stringify(err))
            throw err.response.data
        }
    },
    addQuoteContactToSalesforce: async (id) => {
        const requestData = {
            method: 'post',
            url: `/api/QuoteEdit/AddQuoteContactToSalesforce?id=${id}`,
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            // console.log(JSON.stringify(err))
            throw err.response.data
        }
    },
}

export default PubQuoteEditService